<template>
    <div class="points-detail">
        <loadings v-if="loading"></loadings>
        <template v-else>
            <div class='herder'>
                <span class='back' @click="clickBack"><i></i></span>
                <p>积分明细</p>
            </div>
            <div class="main" ref="myScroll">
                <div class="tips">
                    <strong>学生每完成一次作业，老师即可获得1积分</strong>
                    <p>（如遇积分明细与实际积分不一致，可能是由于换班导致的）</p>
                </div>
                <div class="point-list" v-if="dataList.length">
                    <div class="item" v-for="(item, index) in dataList" @click="getScoreDetail" :key="index">
                        <div class="data">{{ item.date }}</div>
                        <ul>
                            <li v-for="(item2, index2) in item.tmp_list" :key="index2">
                                <div class="unit-name"><i class="icon" :class="item2.sid == 21 ? 'sid21' : 'sid51'"></i> <span>{{
                                    item2.unit_name }}</span></div>
                                <span class="point"><strong>+{{ item2.add_score }}</strong>积分</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <noResouse v-else></noResouse>
            </div>
        </template>
    </div>
</template>

<script>
import loadings from "COMPONENTS/base/loadingS.vue";
import noResouse from "COMPONENTS/noResouse.vue";
export default {
    components: {
        loadings, noResouse
    },
    data () {
        return {
            loading: false,
            dataList: [],
            page_no: 1,
            //每页的条数，一天是一天
            page_size: 10,
            summer_year: 1,
        }
    },
    mounted () {
        this.getScoreDetail();
        window.addEventListener("scroll", this.scrollBottom);
    },
    methods: {
        clickBack () {
            this.$router.go(-1);
        },
        //获取积分明细
        getScoreDetail () {
            this.isLoading = true
            let url = API_URL_HD_API + '/summer/tea/get_score_detail/'
            let params = {
                summer_year: this.summer_year,
                page_no: this.page_no, // 页码 
                page_size: this.page_size  //每页几条
            }
            this.$http.post(url, params).then(res => {
                if (res.data.response === 'ok') {
                    this.isLoading = false
                    if (!res.data.data.length) {
                        layer.tips('已加载全部内容')
                    } else {
                        this.page_no++;
                    }
                    this.dataList = this.dataList.concat(res.data.data);
                    console.log(this.dataList)
                }
            })
        },

        scrollBottom () {
            //加载更多
            var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
            //变量windowHeight是可视区的高度
            var windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            var scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;
            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight && scrollTop > 100) {
                //写后台加载数据的函数
                this.getScoreDetail();
            }
        },
    },
    destroyed () {
        window.removeEventListener("scroll", this.scrollBottom);
    }
}
</script>

<style lang="scss" scoped>
.points-detail {
    background: #f3f3f3;
    min-height: calc(100vh - 2.4rem);
    padding-top: 96px / $ppr;
    padding-bottom: 1px/ $ppr;
}

.herder {
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    background: #ffffff;
    position: fixed;
    z-index: 9;
    top: 0;
    left: 0;
    width: 100%;

    .back {
        width: 64px / $ppr;
        height: 96px / $ppr;
        display: inline-block;
        position: absolute;
        text-align: center;
        top: 0;
        left: 0;
        z-index: 3;

        i {
            width: 16px / $ppr;
            height: 30px / $ppr;
            background: url("./img/icon_img_23.png") no-repeat;
            background-size: 100% 100%;
            display: inline-block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }

    p {
        width: 100%;
        text-align: center;
        height: 90px / $ppr;
        display: inline-block;
        font-size: 36px / $ppr;
        color: #333333;
    }
}

.main {
    .tips {
        text-align: center;
        padding: 25px/$ppr 0 40px/$ppr;

        strong {
            display: block;
            text-align: center;
            font-size: 26px / $ppr;
            color: #999;
            font-weight: bold;
            margin-bottom: 7px/$ppr;
        }

        p {
            font-size: 24px/ $ppr;
            color: #999;
        }
    }

    .point-list {
        padding: 0 24px/$ppr;

        .item {
            margin-bottom: 34px / $ppr;

            .data {
                display: inline-block;
                font-size: 24px / $ppr;
                line-height: 42px / $ppr;
                color: #999999;
                margin-bottom: 15px/$ppr;
            }

            ul {
                background: #fff;
                padding: 0 36px/$ppr;
                border-radius: 10px/$ppr;

                li {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-weight: bold;
                    padding: 29px / $ppr 0;
                    border-top: 1px/$ppr solid #eaeaea;

                    &:first-child {
                        border-top: 0;
                    }

                    .unit-name {
                        display: flex;
                        align-items: center;
                        font-size: 30px/$ppr;
                    }

                    .icon {
                        margin-right: 12px/$ppr;
                        width: 36px/$ppr;
                        height: 36px/$ppr;

                        &.sid21 {
                            background: url("./img/icon_sx.png");
                            background-size: 36px/$ppr 36px/$ppr;
                        }

                        &.sid51 {
                            background: url("./img/icon_yw.png");
                            background-size: 36px/$ppr 36px/$ppr;
                        }
                    }

                    .point {
                        color: #f60;
                        font-size: 28px / $ppr;
                        font-weight: normal;
                        strong {
                            font-size: 34px / $ppr;
                            font-weight: bold;
                            position: relative;
                            top: 2px/ $ppr;
                            left: -2px/ $ppr;
                        }
                    }
                }
            }
        }
    }
}</style>
